import dayjs from "dayjs";
import { GetInteractionsRequest } from "../../api/interaction";
import { SearchFormValues } from "../../types/search/SearchFormValues";
import { GridSortModel } from "@mui/x-data-grid";

const toUndefined = (val: string | null | undefined): string | undefined => {
  return val?.trim() ? val.trim() : undefined;
};

/* istanbul ignore next */
export const convertToRequest = (
  formValues?: SearchFormValues,
  pageSize: number = 100,
  pageIndex: number = 0,
  sortBehavior?: GridSortModel
): GetInteractionsRequest => {
  const request: GetInteractionsRequest = {
    dnis: formValues?.dnis,
    agentName: formValues?.agentName,
    agentNameExactMatch: formValues?.agentNameExactMatch ?? undefined,
    direction: formValues?.direction ?? undefined,
    phoneNumber: formValues?.phoneNumber,
    siteIds: formValues?.siteId ? [formValues.siteId] : undefined,
    from: formValues?.from?.utc().toISOString(),
    to: formValues?.to?.utc().toISOString(),
    fromRetention: formValues?.fromRetention?.utc().toISOString(),
    toRetention: formValues?.toRetention?.utc().toISOString(),
    hasRetention: formValues?.hasRetention ?? undefined,
    minDuration: formValues?.minDuration
      ? formValues.minDuration * 1_000
      : undefined,
    maxDuration: formValues?.maxDuration
      ? formValues.maxDuration * 1_000
      : undefined,
    legalHold: formValues?.legalHold ?? undefined,
    hasMedia: formValues?.hasMedia ?? undefined,
    sourceId: toUndefined(formValues?.sourceId),
    extension: formValues?.extension ?? undefined,
    device: formValues?.device ?? undefined,
    interactionId: toUndefined(formValues?.interactionId),
    masterInteractionId: toUndefined(formValues?.masterInteractionId),
    group: formValues?.group,
    agentId: toUndefined(formValues?.agentId),
    skill: formValues?.skill,
    segmentId: toUndefined(formValues?.segmentId),
    tags: formValues?.tags ?? undefined,
    viewId: toUndefined(formValues?.viewId),
    interactionType: formValues?.interactionType ?? undefined,
    hasTranscription: formValues?.hasTranscription ?? undefined,
    transcriptionStatus: formValues?.transcriptionStatus ?? undefined,
    callId: toUndefined(formValues?.callId),
    pageIndex,
    pageSize,
  };
  if (sortBehavior) {
    request.sortBehavior = sortBehavior;
  }
  return request;
};

export const convertToFormValues = (
  request: GetInteractionsRequest
): SearchFormValues => {
  return {
    dnis: request.dnis ?? "",
    agentName: request.agentName ?? "",
    agentNameExactMatch: request.agentNameExactMatch ?? null,
    direction: request.direction ?? null,
    phoneNumber: request.phoneNumber ?? "",
    siteId: request.siteIds?.[0] ?? null,
    from: request.from ? dayjs(request.from) : null,
    to: request.to ? dayjs(request.to) : null,
    fromRetention: request.fromRetention ? dayjs(request.fromRetention) : null,
    toRetention: request.toRetention ? dayjs(request.toRetention) : null,
    hasRetention: request.hasRetention ?? null,
    minDuration: request.minDuration ? request.minDuration / 1_000 : null,
    maxDuration: request.maxDuration ? request.maxDuration / 1_000 : null,
    legalHold: request.legalHold ?? null,
    hasMedia: request.hasMedia ?? null,
    sourceId: request.sourceId ?? "",
    extension: request.extension ?? "",
    device: request.device ?? "",
    interactionId: request.interactionId ?? "",
    masterInteractionId: request.masterInteractionId ?? "",
    group: request.group ?? "",
    agentId: request.agentId ?? null,
    skill: request.skill ?? "",
    segmentId: request.segmentId ?? "",
    tags: request.tags ?? [],
    viewId: request.viewId ?? "",
    interactionType: request.interactionType ?? null,
    hasTranscription: request.hasTranscription ?? null,
    transcriptionStatus: request.transcriptionStatus ?? null,
  };
};
